'use client'

import styles from './VideoEmbed.module.scss'

type Props = {
  id: string
  title: string
  variant: 'youtube'
}

const CONFIG = {
  youtube: (id: string) => `https://www.youtube.com/embed/${id}?enablejsapi=1`,
} as const

export const VideoEmbed = ({ id, title, variant }: Props) => {
  const link = CONFIG[variant](id)

  return (
    <iframe
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;  web-share'
      allowFullScreen
      className={styles.container}
      loading='lazy'
      src={link}
      title={title}
    />
  )
}
